<template>
<div>
  <div class="emergency-numbers-page">
    <h3>In an Emergency</h3>
    <p><strong>Call 111 when:</strong></p>
    <p>Someone is badly injured or in danger;<br>
      There is a serious risk to life or property;<br>
      A crime is being committed and the offenders are still there or have just left.</p>
    <p>To report a historic incident eg. Overnight break-in or something that happened a few days ago call Auckland Central Police on&nbsp;<a href="tel:09 302 6400">09 302 6400</a>&nbsp;and ask for the Crime Reporting Line.<br>
      Alternatively contact the Manurewa Police on&nbsp;<a href="tel:09 268 5800">09 268 5800</a>&nbsp; or visit them between 8am and 4pm Monday to Friday at 14 Halver Road, Manurewa.</p>
    <h3>Defibrillator</h3>
    <p>In case of a medical emergency, the nearest defibrillators are located at:</p>
    <h4>Manurewa</h4>
    <p>• The Peoples Centre – 7 Halver Rd, Manurewa – <a href="tel:09 268 6331">09 268 6331</a><br>
      • ASB – 10/214 Great South Road, Manurewa, Auckland 2102<br>
      • Manurewa Medical Centre – 157 Great South Rd, Manurewa – <a href="tel:09 266 90445">09 266 9044</a><br>
      • Greenstone Family Clinic – 157 Great South Road, Manurewa – <a href="tel:09 267 8702">09 267 8702</a><br>
      • Manurewa Leisure Centre – 33 Frances St, Manurewa 2102 – <a href="tel:09 267 4646">09 267 4646</a><br>
      • Manurewa High School – 67 Browns Rd, Manurewa 2102 – <a href="tel:09 269 0690">09 269 0690</a></p>
    <p>PLEASE NOTE: AED may not be available for use at certain times from all locations</p>
    <h4>Clendon</h4>
    <p>•Clendon Medical Centre -15 Palmers Rd -  09-267-4525 <br>
      •	Te Matariki Clendon Comm Centre -17 Palmers Rd - 09-269-0500 <br>
      •	New World Clendon - 459-469 Roscommon Rd - 09 266 5010 <br>
      •	Clendon Family Health Centre - 9 Robert Ross Place - 09-267-2636 <br>
      •	McDonald's - Clendon - 24/7 - 443 Roscommon Rd - 09-267-6320 <br>
      •	Finlayson Park School - 85 John Walker Drive -  09-266 5558 <br>
      •	Manurewa Aquatic Centre - 83 Sykes Rd -  09-269-0930 <br>
      •	Manurewa Marae - Te Manu Aute Whare Oranga - 81 Finlayson Ave - 09 640-0824 <br>
      •	Rowandale School - School Office - 73 Rowandale Avenue <br>
      •	East Tamaki Health Care - Weymouth - 235 Browns Rd - 09-264-1640 <br>
    </p>
    <p>PLEASE NOTE: AED may not be available for use at certain times from all locations</p>
    <h4>Apple Play app download link</h4>
    <a href="https://apps.apple.com/nz/app/aed-locations/id424094430">Download</a>
    <h4>Google Play Store app download link</h4>
    <a href="https://play.google.com/store/apps/details?id=com.abletech.aedlocations&hl=en_NZ&gl=US">Download</a>
  </div>
</div>
</template>

<script>
export default {
  name: "EmergencyNumbers"
}
</script>

<style scoped lang="scss">
.emergency-numbers-page {
  color: white;
  font-size: 1rem;
  padding: 1rem;
  a {
    color: #2dbc5d;
    font-weight: bold;
    text-decoration: none;
  }
}
</style>
